import { useQuery } from "@tanstack/react-query";
import { ConsultProposalResponseDTO } from "@repo/core/services/entities/Proposals";
import { apiInstance } from "@repo/core/services/instances/api";
import { ProposalsResource } from "@repo/core/services/resources/proposals";
import {
  findServicePointByCode,
  getProposalServicePointsParams,
  getProposalServicePointsQueryKey
} from "@repo/core/utils/servicePoint.utils";

const proposalsResource = new ProposalsResource(apiInstance);

export const useProposalServicePoints = (
  productCode?: string,
  brandCode?: string
) => {
  const normalizedProductCode = productCode?.trim() || "";
  const normalizedBrandCode = brandCode?.trim() || "";

  return useQuery({
    queryKey: getProposalServicePointsQueryKey(
      normalizedProductCode,
      normalizedBrandCode
    ),
    queryFn: () =>
      proposalsResource.fetchPoints(
        getProposalServicePointsParams(
          normalizedProductCode,
          normalizedBrandCode
        )
      ),
    select: (response) => response.data,
    enabled: Boolean(normalizedProductCode && normalizedBrandCode)
  });
};

export const useSelectedProposalServicePoint = (
  proposalData?: Partial<ConsultProposalResponseDTO>
) => {
  const query = useProposalServicePoints(
    proposalData?.strProduto,
    proposalData?.strBandeira
  );

  return {
    ...query,
    selectedServicePoint: findServicePointByCode(
      query.data,
      proposalData?.strPontoAtendimento
    )
  };
};
